module.exports = __webpack_public_path__ + "img/logo.ed70f11b.png";